export interface ISystemReview {
  systemReviewId: number;
  reviewType: string;
  reviewVendor: string;
  reviewDate: Date;
  description: string;
  editing: boolean;
}

export class SystemReview implements ISystemReview {
  systemReviewId: number;
  reviewType: string;
  reviewVendor: string;
  reviewDate: Date;
  description: string;
  editing = false;
}
